import React from 'react';

import Table, { TableCell, TableRow } from '@amzn/meridian/table';
import UncontrolledExpandableRow from 'src/components/shared/uncontrolledExpandableRow/uncontrolledExpandableRow';
import { useAppSelector } from 'src/store/store';
import { removeSpecialCharactersFromString } from 'src/utils/helpers';

const PlacementSelections = () => {
  const { featureFlags } = useAppSelector((state) => state.user);
  const { placementDetails, placementSite } = useAppSelector((state) => state.placementDetailsPage);

  const jobModificationsEnabled = featureFlags.JOB_MODIFICATIONS && !!placementSite?.jobModificationsEnabled;

  return (
    <Table headerRows={1} rowComponents={[UncontrolledExpandableRow, TableRow]} showStripes={true} showDividers={true}>
      <TableRow>
        <TableCell>Job(s)</TableCell>
        {jobModificationsEnabled && <TableCell>Modification(s)</TableCell>}
        <TableCell>Shift</TableCell>
        <TableCell>Job Type</TableCell>
        <TableCell>Hours Assigned</TableCell>
      </TableRow>

      {placementDetails.jobsDisplayed &&
        placementDetails?.allocatedJobShifts?.map((jobShift, index) => (
          <TableRow key={index} data-cy="placement-details__job-row">
            <TableCell
              data-cy={`placement-details__placements__job-${removeSpecialCharactersFromString(jobShift.jobName)}`}
            >
              {jobShift.jobName} {placementDetails.jobSuffix}
            </TableCell>
            {jobModificationsEnabled && (
              <TableCell>
                {[...new Set(jobShift.appliedModifications.map((am) => am.modification.name))].join(', ')}
              </TableCell>
            )}
            <TableCell>{jobShift.shiftCode}</TableCell>
            <TableCell>{jobShift.jobType}</TableCell>
            <TableCell
              data-cy={`placement-details__placements__hours-${removeSpecialCharactersFromString(jobShift.jobName)}`}
            >
              {jobShift.allocatedHours}
            </TableCell>
          </TableRow>
        ))}
    </Table>
  );
};

export default PlacementSelections;
